import { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";
import {
    BoxContainer,
    BoxHead,
    DownloadBtn,
    Underline,
} from "../../Components/Styles/PageStyles";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Config from "../../Config";
import { useSelector } from "react-redux";
import { useMutation } from "react-query";
import DeleteProperty from "../../Components/Properties/DeleteProperty";
import SideModal from "../../Components/SideModal";
import { FaBuilding } from "react-icons/fa";
import { capitalizeFirstLetter, handleCopy } from "../../helpers";
import PropertyDetailModal from "../../Components/Properties/Details/PropertyDetailModal";
import PropertyFineDetail from "../../Components/Properties/Details/PropertyFineDetail";
import PropertyDocuments from "../../Components/Properties/Details/PropertyDocuments";
import { TenantDetailsLoading } from "../../Components/SkeletonLoading";
import LeaseDetails from "../../Components/Properties/Details/LeaseDetails";
import ExtraChargesTable from "../../Components/Properties/Details/ExtraChargesTable";
// import AddExtraCharges from "../../Components/Properties/AddExtraCharges";
import Menu from "../../Components/Properties/Details/Menu";
import UnlinkCharges from "../../Components/Properties/Details/UnlinkCharges";
import moment from "moment";
import NotFoundModel from "../../Components/NotFoundModel";
import InventoryImagesModal from "../../Components/Properties/Details/PropertyMedia";
import LandlordLeaseViewModal from "../../Components/Properties/Details/LandlordLeaseViewModal";
import { FiShare2 } from "react-icons/fi";
import WebsiteVisibilityProperty from "../../Components/Properties/WebsiteVisibilityProperty";
import Tooltip from "../../Components/Tooltip";
import WifiPasswordModal from "../../Components/Properties/Details/WifiPasswordModal";
import { IoCopySharp } from "react-icons/io5";
import CommonAddExtraCharges from "../../Components/Common/CommonAddExtraCharges";

const PropertyDetail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const propertyDetails = location.state?.propertyDetails;
    const user = useSelector((state) => state.UserReducer.user);
    const [activeTab, setActiveTab] = useState("overview");
    const [isDeleteProperty, setIsDeleteProperty] = useState(false);
    const [isWifiPassword, setIsWifiPassword] = useState(false);
    const [isWebsiteVisibilityProperty, setIsWebsiteVisibiltyProperty] = useState(false);
    const [docs, setDocs] = useState([]);
    const [isDocumentAdd, setIsDocumentAdd] = useState(false);
    const [apiData, setApiData] = useState();
    const [propData, setPropData] = useState();
    const [isAddExtraCharges, setIsAddExtraCharges] = useState(false);
    const [showLinkUnlinkModel, setShowLinkUnlinkModel] = useState(false);
    const [selectedData, setSelectedData] = useState("");
    const [isMediaAdd, setIsMediaAdd] = useState(false);
    const [isMediaEdit, setIsMediaEdit] = useState(false);
    const [isVisibleToClient, setIsVisibleToClient] = useState(true);
    const [viewDetails, setViewDetails] = useState(false);

    const fetchFunction = async () => {
        const response = await axios.get(
            `${Config.apiUrl}/property/details/${propertyDetails?.id}`,
            {
                headers: {
                    authorization: `Bearer ${user.token}`,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            },
        );
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.data === false) error = true;
        else {
            setApiData(res?.data);
            setPropData(res);
            setDocs(res?.data?.docs);
            setIsVisibleToClient(res?.data?.property?.isVisibleOnWebsite === 1 ? true : false)
        }
    };

    const getError = (res) => { };

    const {
        isLoading,
        mutate: getListMutate,
        error,
        data,
        isRefetching,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });

    useEffect(() => {
        getListMutate();
    }, []);

    //------- Delete Property -------
    const deletePropertyFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/property/delete`, values, {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const deletePropertySuccess = (data) => {
        setIsDeleteProperty(false);
        navigate("/property-list")
        toast.success(data?.data?.msg || "Success");
    };

    const deletePropertyError = (data) => {
        setIsDeleteProperty(false);
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: deletePropertyLoading, mutate: deletePropertyMutate } =
        useMutation(deletePropertyFunction, {
            onSuccess: deletePropertySuccess,
            onError: deletePropertyError,
        });

    //------- Edit Property Name -------
    const editNameFunction = async (values) => {
        return await axios.post(
            `${Config.apiUrl}/property/edit/details`,
            values,
            {
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${user.token}`,
                },
            },
        );
    };

    const editNameSuccess = (data) => {
        toast.success(data?.data?.msg || "Success");
    };

    const editNameError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: editNameLoading, mutate: editNameMutate } = useMutation(
        editNameFunction,
        {
            onSuccess: editNameSuccess,
            onError: editNameError,
        },
    );

    //------- Edit Fine Details -------
    const editFineDetailsFunction = async (values) => {
        return await axios.post(
            `${Config.apiUrl}/property/update/fine/details`,
            values,
            {
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${user.token}`,
                },
            },
        );
    };

    const editFineDetailsSuccess = (data) => {
        toast.success(data?.data?.msg || "Success");
    };

    const editFineDetailsError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: editFineDetailsLoading, mutate: editFineDetailsMutate } =
        useMutation(editFineDetailsFunction, {
            onSuccess: editFineDetailsSuccess,
            onError: editFineDetailsError,
        });

    //------- Upload Document -------
    const uploadDocumentFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/property/add/document`, values, {
            headers: {
                authorization: `Bearer ${user.token}`,
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        });
    };

    const onUploadDocSuccess = (data) => {
        setIsDocumentAdd(false);
        if (data?.data?.isSuccess === true) {
            setDocs(data?.data?.docs);
            toast.success(data?.data?.msg || "Success");
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onUploadDocError = (data) => {
        setIsDocumentAdd(false);
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: isDocLoading, mutate: uploadDocMutate } = useMutation(
        uploadDocumentFunction,
        {
            onSuccess: onUploadDocSuccess,
            onError: onUploadDocError,
        },
    );

    //------- Add Extra Charges -------
    const addExtraChargesFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/extra-charges/add`, values, {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const addExtraChargesSuccess = (data) => {
        setIsAddExtraCharges(false);
        getListMutate();
        toast.success(data?.data?.msg || "Success");
    };

    const addExtraChargesError = (data) => {
        setIsAddExtraCharges(false);
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: addExtraChargesLoading, mutate: addExtraChargesMutate } =
        useMutation(addExtraChargesFunction, {
            onSuccess: addExtraChargesSuccess,
            onError: addExtraChargesError,
        });

    const handleAddExtraChargesClose = () => {
        setIsAddExtraCharges(false);
    };

    //------- Link Property  -------
    const linkPropertyFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/extra-charges/toggle`, values, {
            headers: {
                authorization: `Bearer ${user.token}`,
                "Content-Type": "application/json",
            },
        });
    };
    const onLinkPropertyeSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Success");
            setShowLinkUnlinkModel(false);
            getListMutate();
        } else {
            toast.error(data?.rdata?.msg || "An Error Occured");
        }
    };

    const onLinkPropertyError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const {
        isLoading: linkPropertyLoading,
        mutate: linkPropertyMutate,
    } = useMutation(linkPropertyFunction, {
        onSuccess: onLinkPropertyeSuccess,
        onError: onLinkPropertyError,
    });

    //------- Upload Media -------
    const uploadMediaFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/property/add/image`, values, {
            headers: {
                authorization: `Bearer ${user.token}`,
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        });
    };

    const onUploadMediaSuccess = (data) => {
        setIsMediaAdd(false);
        if (data?.data?.isSuccess === true) {
            getListMutate()
            toast.success(data?.data?.msg || "Success");
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onUploadMediaError = (data) => {
        setIsDocumentAdd(false);
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: isMediaLoading, mutate: uploadMediaMutate } = useMutation(
        uploadMediaFunction,
        {
            onSuccess: onUploadMediaSuccess,
            onError: onUploadMediaError,
        },
    );


    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const handleImageNavigation = (direction) => {
        if (!propData?.propImages || propData?.propImages.length === 0) return;

        if (direction === "prev") {
            setCurrentImageIndex((prev) => (prev === 0 ? propData?.propImages.length - 1 : prev - 1));
        } else {
            setCurrentImageIndex((prev) => (prev === propData?.propImages.length - 1 ? 0 : prev + 1));
        }
    };
    const handleShare = (item) => {
        const url = `${Config.propertyShareUrl}/${item}`;

        const message = `Check out this property:\n${url}`;

        window.open(`https://wa.me/?text=${encodeURIComponent(message)}`);
    };

    //------- Website Visibility Property -------
    const websiteVisibilityFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/property/toggle/website/visibility`, values, {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const websiteVisibilitySuccess = (data, variables) => {
        setIsWebsiteVisibiltyProperty(false);

        // update local apiData (no refetch)
        setApiData((prev) => ({
            ...prev,
            property: {
                ...prev.property,
                isVisibleOnWebsite: variables.isVisible,
            },
        }));

        toast.success(data?.data?.msg || "Success");
    };

    const websiteVisibilityError = (data) => {
        setIsWebsiteVisibiltyProperty(false);
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: websiteVisibilityLoading, mutate: websiteVisibilityMutate } =
        useMutation(websiteVisibilityFunction, {
            onSuccess: websiteVisibilitySuccess,
            onError: websiteVisibilityError,
        });
    const handleDetailModalClose = () => {
        setViewDetails(false);
    };
    const handleWifiModalClose = () => {
        setIsWifiPassword(false);
    };

    //------- Wifi Details -------
    const wifiDetailsFunction = async (values) => {
        return await axios.post(
            `${Config.apiUrl}/property/update/wifi/password`, values,
            // {
            //     propId: values.propId,
            //     wifiPassword: values.wifiPassword
            // },
            {
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${user.token}`,
                },
            },
        );
    };
    const wifiDetailsSuccess = (data) => {
        toast.success(data?.data?.msg || "Success");
        setIsWifiPassword(false);
        getListMutate()
    };

    const wifiDetailsError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: wifiDetailsLoading, mutate: wifiDetailsMutate } =
        useMutation(wifiDetailsFunction, {
            onSuccess: wifiDetailsSuccess,
            onError: wifiDetailsError,
        });
    return (
        <BoxContainer>
            {isDeleteProperty && (
                <DeleteProperty
                    setIsDeleteProperty={setIsDeleteProperty}
                    isDeleteProperty={isDeleteProperty}
                    deletePropertyLoading={deletePropertyLoading}
                    deletePropertyMutate={deletePropertyMutate}
                    selectedData={propertyDetails}
                />
            )}

            {showLinkUnlinkModel && (
                <UnlinkCharges
                    setShowLinkUnlinkModel={setShowLinkUnlinkModel}
                    showLinkUnlinkModel={showLinkUnlinkModel}
                    linkPropertyLoading={linkPropertyLoading}
                    linkPropertyMutate={linkPropertyMutate}
                    selectedData={selectedData}
                    propId={propertyDetails?.id}
                />
            )}
            {isAddExtraCharges &&
                <SideModal
                    isOpen={isAddExtraCharges}
                    onClose={() => setIsAddExtraCharges(false)}
                >
                    {/* <AddExtraCharges
                        setIsAddExtraCharges={setIsAddExtraCharges}
                        isAddExtraCharges={isAddExtraCharges}
                        handleClose={handleAddExtraChargesClose}
                        addExtraChargesLoading={addExtraChargesLoading}
                        addExtraChargesMutate={addExtraChargesMutate}
                        propId={propertyDetails?.id}
                        propertyDetails={propertyDetails}
                    /> */}
                    <CommonAddExtraCharges
                        handleClose={handleAddExtraChargesClose}
                        addExtraChargesLoading={addExtraChargesLoading}
                        addExtraChargesMutate={addExtraChargesMutate}
                        propId={propertyDetails?.id}
                        propertyDetails={propertyDetails}
                        modalType="SINGLE_PROPERTY"
                    />
                </SideModal>}
            <SideModal
                isOpen={viewDetails}
                onClose={handleDetailModalClose}
            >
                <LandlordLeaseViewModal
                    setViewDetails={setViewDetails}
                    selectedData={selectedData}
                />
            </SideModal>

            <SideModal
                isOpen={isWifiPassword}
                onClose={handleWifiModalClose}
            >
                <WifiPasswordModal
                    setIsWifiPassword={setIsWifiPassword}
                    isWifiPassword={isWifiPassword}
                    wifiDetailsMutate={wifiDetailsMutate}
                    wifiDetailsLoading={wifiDetailsLoading}
                    selectedData={propData?.data?.property}
                    handleDetailModalClose={handleWifiModalClose}
                />
            </SideModal>
            {!error && !isLoading && data && (
                <PageWrapper>
                    <CardContainer>
                        <HeaderWrapper>
                            <ProfileWrapper>
                                <AvatarWrapper>
                                    <IconWrapper>
                                        <FaBuilding className="text-gray-600 items-center" size={24} />
                                    </IconWrapper>
                                </AvatarWrapper>
                                <TenantInfos>
                                    <NameWrapper>
                                        <TenantName>
                                            {capitalizeFirstLetter(apiData?.property?.name)}
                                        </TenantName>
                                    </NameWrapper>
                                    <TenantProp>{apiData?.property?.address}</TenantProp>
                                </TenantInfos>
                            </ProfileWrapper>
                            <Tooltip label="Share Property">
                                <FiShare2 className="text-gray-500 mr-2 cursor-pointer hover:text-gray-800" onClick={() => handleShare(apiData?.property?.gId)} />
                            </Tooltip>
                        </HeaderWrapper>

                        {/* ================= BODY ================= */}
                        <CardBody>
                            <InfoGrid>
                                <InfoItem>
                                    <InfoLabel>Property Id</InfoLabel>
                                    <div className="flex items-center gap-1">
                                        <InfoValue>#{apiData?.property?.gId}
                                        </InfoValue>
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleCopy(apiData?.property?.gId);
                                            }}
                                            className="hover:text-gray-600 transition text-gray-500"
                                            title="Copy property id"
                                        >
                                            <IoCopySharp size={12} />
                                        </button>
                                    </div>
                                </InfoItem>
                                <InfoItem>
                                    <InfoLabel>Total Beds</InfoLabel>
                                    <InfoValue>
                                        {apiData?.beds?.occupied}/{apiData?.beds?.total}
                                    </InfoValue>
                                </InfoItem>

                                <InfoItem>
                                    <InfoLabel>Vacant Beds</InfoLabel>
                                    <InfoValue>{apiData?.beds?.vacant}</InfoValue>
                                </InfoItem>

                                <InfoItem>
                                    <InfoLabel>Total Tenants</InfoLabel>
                                    <InfoValue>{apiData?.summary?.totalTenants}</InfoValue>
                                </InfoItem>
                                <InfoItem>
                                    <InfoLabel>MovedOut Tenants</InfoLabel>
                                    <InfoValue>{apiData?.summary?.moveOut}</InfoValue>
                                </InfoItem>
                            </InfoGrid>
                        </CardBody>
                    </CardContainer>
                    <MainContent>
                        <div className="mx-auto flex justify-between">
                            <TabContainer>
                                <Tab
                                    active={activeTab === "overview"}
                                    onClick={() => setActiveTab("overview")}
                                >
                                    Property Info
                                </Tab>

                                <Tab
                                    active={activeTab === "documents"}
                                    onClick={() => setActiveTab("documents")}
                                >
                                    Documents
                                </Tab>
                                <Tab
                                    active={activeTab === "landlord"}
                                    onClick={() => setActiveTab("landlord")}
                                >
                                    Landlord
                                </Tab>
                                <Tab
                                    active={activeTab === "extraCharges"}
                                    onClick={() => setActiveTab("extraCharges")}
                                >
                                    Extra Charges
                                </Tab>
                                <Tab
                                    active={activeTab === "media"}
                                    onClick={() => setActiveTab("media")}
                                >
                                    Media
                                </Tab>
                            </TabContainer>
                            <Menu
                                setIsDeleteProperty={setIsDeleteProperty}
                                setIsWebsiteVisibiltyProperty={setIsWebsiteVisibiltyProperty}
                                setIsWifiPassword={setIsWifiPassword}
                            />
                        </div>

                        {/* Tab Content */}
                        <TabContent>
                            {activeTab === "overview" && (
                                <OverviewTab
                                    propertyDetails={propertyDetails}
                                    editNameLoading={editNameLoading}
                                    editNameMutate={editNameMutate}
                                    editFineDetailsLoading={editFineDetailsLoading}
                                    editFineDetailsMutate={editFineDetailsMutate}
                                    apiData={apiData}
                                    setIsVisibleToClient={setIsVisibleToClient}
                                    isVisibleToClient={isVisibleToClient}
                                    websiteVisibilityMutate={websiteVisibilityMutate}
                                    websiteVisibilityLoading={websiteVisibilityLoading}
                                    propId={propertyDetails?.id}

                                />
                            )}

                            {activeTab === "documents" && (
                                <>
                                    <PropertyDocuments
                                        docs={docs}
                                        uploadDocMutate={uploadDocMutate}
                                        isDocLoading={isDocLoading}
                                        setIsDocumentAdd={setIsDocumentAdd}
                                        isDocumentAdd={isDocumentAdd}
                                        propId={propertyDetails?.id}
                                    />
                                </>
                            )}

                            {activeTab === "landlord" && (
                                <LeaseDetails
                                    landlordData={propData?.landlordData}
                                    leaseDetails={propData?.leaseDetails}
                                    setSelectedData={setSelectedData}
                                    setViewDetails={setViewDetails}
                                />
                            )}
                            {activeTab === "extraCharges" && (
                                <ExtraChargesTab
                                    apiData={apiData?.extraCharges}
                                    propertyDetails={propertyDetails}
                                    error={error}
                                    setIsAddExtraCharges={setIsAddExtraCharges}
                                    isAddExtraCharges={isAddExtraCharges}
                                    handleAddExtraChargesClose={handleAddExtraChargesClose}
                                    addExtraChargesLoading={addExtraChargesLoading}
                                    addExtraChargesMutate={addExtraChargesMutate}
                                    isLoading={isLoading}
                                    setShowLinkUnlinkModel={setShowLinkUnlinkModel}
                                    selectedData={selectedData}
                                    setSelectedData={setSelectedData}
                                    user={user}
                                />
                            )}
                            {activeTab === "media" && (
                                <InventoryImagesModal
                                    images={propData?.propImages}
                                    // images={property.images}
                                    currentImageIndex={currentImageIndex}
                                    setCurrentImageIndex={setCurrentImageIndex}
                                    handleImageNavigation={handleImageNavigation}
                                    isMediaAdd={isMediaAdd}
                                    setIsMediaAdd={setIsMediaAdd}
                                    propId={propertyDetails?.id}
                                    uploadMediaMutate={uploadMediaMutate}
                                    isMediaLoading={isMediaLoading}
                                    setIsMediaEdit={setIsMediaEdit}
                                    isMediaEdit={isMediaEdit}
                                    setSelectedData={setSelectedData}
                                    selectedData={selectedData}
                                    editMediaMutate={uploadMediaMutate}
                                    isEditMediaLoading={isMediaLoading}
                                    apiData={apiData}
                                />
                            )}
                        </TabContent>
                    </MainContent>
                </PageWrapper>
            )}
            {(isLoading || isRefetching) && <TenantDetailsLoading />}
        </BoxContainer>
    );
};

const OverviewTab = ({
    propertyDetails,
    editNameLoading,
    editNameMutate,
    editFineDetailsLoading,
    editFineDetailsMutate,
    apiData,
    isVisibleToClient,
    setIsVisibleToClient,
    websiteVisibilityMutate,
    websiteVisibilityLoading,
    propId,

}) => {
    const propertyType = [
        { value: 1, label: "PG/Hostel/Co-Living" },
        { value: 2, label: "Flat/Apartment" },
    ];

    return (
        <Wrapper>
            <BoxHead>
                <TabTitle className="!mb-0 whitespace-nowrap">
                    Property Info
                    <Underline />
                </TabTitle>
                <div className="flex items-center gap-3 text-xs">

                    {/* TYPE BADGE */}
                    <span className="px-2 py-1 rounded-md bg-gray-100 text-gray-700 font-medium">
                        {propertyType.find(opt => opt.value === apiData?.property?.type)?.label}
                    </span>

                    {/* DIVIDER */}
                    <span className="text-gray-300">|</span>

                    {/* CREATED */}
                    <span className="text-gray-500">
                        {apiData?.property?.createdAt}
                    </span>

                </div>
            </BoxHead>
            <PropertyDetailModal
                editNameLoading={editNameLoading}
                editNameMutate={editNameMutate}
                selectedData={propertyDetails}
                apiData={apiData}
            />
            {/* <BoxHead>
                <TabSubTitle> Fine Details</TabSubTitle>
            </BoxHead> */}
            <PropertyFineDetail
                editFineDetailsLoading={editFineDetailsLoading}
                editFineDetailsMutate={editFineDetailsMutate}
                selectedData={propertyDetails}
                apiData={apiData}
            />

            <div className="flex items-center justify-between mt-4 p-3 rounded-md border border-gray-200 bg-gray-50">
                <div>
                    <p className="text-sm font-medium text-gray-800">
                        Publish to Website
                    </p>
                    <p className="text-xs text-gray-500">
                        Make this property visible on the website
                    </p>

                    <p className="text-[11px] text-gray-400 mt-1">
                        Applies only to Kipinn-managed websites
                    </p>
                </div>

                <button
                    type="button"
                    disabled={websiteVisibilityLoading}
                    onClick={() => {
                        const newVisibility = isVisibleToClient ? 0 : 1;

                        // optimistic update
                        setIsVisibleToClient(!isVisibleToClient);

                        websiteVisibilityMutate({ propId: propId, isVisible: newVisibility });
                    }}
                    className={`relative inline-flex h-7 w-12 items-center rounded-full transition-all duration-200 ${isVisibleToClient ? "bg-primary-color" : "bg-gray-300"
                        } ${websiteVisibilityLoading ? "opacity-70 cursor-not-allowed" : ""}`}
                >
                    <span
                        className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-md transition-all duration-200 ${isVisibleToClient ? "translate-x-6" : "translate-x-1"
                            }`}
                    >
                        {websiteVisibilityLoading && (
                            <span className="absolute inset-0 flex items-center justify-center">
                                <span className="h-3 w-3 border-2 border-gray-400 border-t-transparent rounded-full animate-spin" />
                            </span>
                        )}
                    </span>
                </button>
            </div>




        </Wrapper>
    );
};

const ExtraChargesTab = ({
    propertyDetails,
    error,
    apiData,
    setIsAddExtraCharges,
    isAddExtraCharges,
    handleAddExtraChargesClose,
    addExtraChargesLoading,
    addExtraChargesMutate,
    isLoading,
    setShowLinkUnlinkModel,
    selectedData,
    setSelectedData,
    user
}) => {
    return (
        <>
            <Wrapper>
                <BoxHead>
                    <TabTitle className="!mb-0 whitespace-nowrap">
                        Extra Charges
                        <Underline />
                    </TabTitle>
                    {user?.role !== Config.STAFF_ROLES.SALES_HEAD &&
                        <DownloadBtn type="button" onClick={() => setIsAddExtraCharges(true)}>
                            Add Charges
                        </DownloadBtn>
                    }
                </BoxHead>
                {(error || apiData === false) && !isLoading && (
                    <NotFoundModel msg={"No extra charges added yet"} />
                    // <div className="flex justify-center items-center py-10">
                    //     <p className="text-gray-400 text-sm">No Extra Charges Added Yet.</p>
                    // </div>
                )}
                {!error && !isLoading && apiData?.length > 0 && (
                    <TableWrapper>
                        <ExtraChargesTable
                            apiData={error ? [] : apiData}
                            propertyDetails={propertyDetails}
                            setShowLinkUnlinkModel={setShowLinkUnlinkModel}
                            selectedData={selectedData}
                            setSelectedData={setSelectedData}
                        />
                    </TableWrapper>
                )}
            </Wrapper>
        </>
    );
};

const MainContent = tw.div`p-3 rounded-lg bg-white shadow-sm mt-6`;
const TabContainer = tw.div`flex overflow-x-auto gap-6 px-4`;
const Tab = tw.button`relative px-1 py-3 text-sm whitespace-nowrap 
 ${({ active }) =>
        active
            ? "text-zinc-900 font-semibold border-b-2 border-zinc-900"
            : "text-zinc-500 font-normal hover:text-zinc-700"}`;
const TabContent = tw.div`py-6`;
const CardContainer = tw.div`bg-white rounded-xl shadow-sm border border-gray-200/60 overflow-hidden`;
const HeaderWrapper = tw.div`flex items-start justify-between gap-6 p-5 border-b border-gray-100`;
const ProfileWrapper = tw.div`flex items-center gap-4 z-index`;
const TenantInfos = tw.div`flex-1 min-w-0`;
const NameWrapper = tw.div`flex items-center gap-3`;
const TenantName = tw.h2`text-md font-semibold text-gray-900 truncate`;
const TenantProp = tw.p`text-sm text-gray-500 flex-wrap`;
const CardBody = tw.div`p-5`;
const InfoGrid = tw.div`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6`;
const InfoItem = tw.button``;
const InfoLabel = tw.div`flex items-center gap-2 text-gray-500 text-sm`;
const InfoValue = tw.p`text-base font-semibold text-gray-900 text-left`;
const Wrapper = tw.div`px-4 space-y-4 mt-2`;
const TabTitle = tw.h2`
${(p) => (p.$fullWidth ? "flex inline-flex" : "justify-center")}
text-lg  text-black font-semibold  space-x-2 items-center  mb-5  rounded-md `;
const TabSubTitle = tw.h3`text-md md:text-md lg:text-md tracking-wider font-semibold pb-2 text-black`;
const TableWrapper = tw.div`border bg-white rounded-md `;
// const AddBtn = tw.button`${(p) => (p.$active ? "bg-gray-100" : "")}
// border whitespace-nowrap border-gray-200 
// flex space-x-1.5 justify-center items-center 
// text-white h-full rounded-md px-6 cursor-pointer 
// bg-primary-color/70 hover:bg-primary-color 
// py-2.5 text-sm
// `;
const BtnWrapper = tw.div` pt-4 flex justify-end`;
const AddBtn = tw.button`${(p) =>
    p.$active
        ? "bg-gray-100"
        : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 py-2.5 text-sm`;
const PageWrapper = tw.div`px-1`;
const AvatarWrapper = tw.div`flex items-center justify-center w-12 h-12`;
const IconWrapper = tw.div`w-12 h-12 items-center rounded-full shadow-lg flex items-center justify-center bg-gray-100`;
const Active = tw.div`bg-emerald-50 text-emerald-700 text-xs font-medium px-2.5 w-auto h-6 flex items-center justify-center rounded-full`;
const InActive = tw.div`bg-gray-50 text-gray-700 text-xs font-medium px-2.5 w-auto h-6 flex items-center justify-center rounded-full`;
export default PropertyDetail;
